import { PasswordStrenghtEntryMessage } from "@/components/common/signup-login-wall/PasswordStrenghtEntryMessage";
import { PasswordStrengthEntryIcon } from "@/components/common/signup-login-wall/PasswordStrengthEntryIcon";

type PasswordStrengthEntryProps = {
  state?: "default" | "valid" | "invalid";
  message: string;
};

export const PasswordStrengthEntry = ({
  state,
  message,
}: PasswordStrengthEntryProps) => {
  return (
    <span className="flex items-center space-x-2">
      <PasswordStrengthEntryIcon state={state} />
      <PasswordStrenghtEntryMessage state={state}>
        {message}
      </PasswordStrenghtEntryMessage>
    </span>
  );
};
